module.exports = __webpack_public_path__ + "static/media/Chili's Logo-01.e84e275e.svg";